import React from "react";
import PropTypes from "prop-types";
import "./ResumeItem.css";  // Make sure to create this CSS file for styling

const ResumeItem = ({ title, timeline, place, description, skills }) => {
  return (
    <div className="timeline-item">
      <div className="timeline-content">
        <h3>{title}</h3>
        <p className="timeline-date">{timeline}</p>
        <p><strong>Place:</strong> {place}</p>
        <p><strong>Description:</strong> {description}</p>
        {skills && (
          <div>
            <strong>Skills:</strong>
            <ul>
              {Object.values(skills).map((skill, index) => (
                <li key={index}>{skill}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

ResumeItem.propTypes = {
  title: PropTypes.string.isRequired,
  timeline: PropTypes.string.isRequired,
  place: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  skills: PropTypes.object,
};

export default ResumeItem;
